import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '@/store'
import i18n from '@/i18n'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Registration',
        component: () => import(/* webpackChunkName: "registration" */ '@/views/Registration')
    },
    {
        path: '/otp',
        name: 'OTP',
        component: () => import(/* webpackChunkName: "otp" */ '@/views/OTP')
    },
    {
        path: '/r/:referral',
        name: 'Registration',
        component: () => import(/* webpackChunkName: "referral" */ '@/views/Registration')
    },
    {
        path: '/download',
        name: 'Download',
        component: () => import(/* webpackChunkName: "download" */ '@/views/Download')
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

const getBrowserLanguage = () => {
    const availableLanguage = process.env.VUE_APP_SUPPORTED_LANG.toLowerCase().split(',')
    const browserLanguage = navigator.language

    if (availableLanguage.indexOf(browserLanguage.toLowerCase()) > -1) {
        return browserLanguage
    }

    return process.env.VUE_APP_DEFAULT_LANG
}

router.beforeEach((to, from, next) => {
    let lang = to.query.lang

    if (!lang) {
        lang = getBrowserLanguage()
    }

    Store.dispatch('changeLanguage', lang)

    Object.assign(to.query, { lang: lang })

    i18n.locale = lang

    next()
})

export default router
